import request from "@/utils/request";

// 列表(主数据列表)
export function loadMarketManagerSettingListDataApi(data) {
  return request({
    url: "web/marketManagerSetting/listData",
    method: "post",
    data
  });
}
// 导出
export function loadMarketManagerSettingExportDataApi(data) {
  return request({
    url: "web/marketManagerSetting/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateMarketManagerSettingApi(data) {
  return request({
    url: "web/marketManagerSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initMarketManagerSettingApi(data) {
  return request({
    url: "web/marketManagerSetting/init",
    method: "post",
    data
  });
}